import {IOverride} from "../../index";

interface IParams {
    override: IOverride
}

interface IStatus extends IMoreStatus {
    by: string
    icon: string
    id: number
    when: string
    value: string
}

interface IMoreStatus {
    title: string
    synchronized: string
    what: string
}

interface IWhomWhen {
    by: string
    id: number
    when: string
}

